export const CHECK_PROMOCODE = 'CHECK_PROMOCODE';